const $$splitComponentImporter = () => import('/app/frontend/src/routes/_app/fleet-management/drivers/new.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { DRIVER_DETAIL_TABS } from '@/features/fleet-management/driver/model/driver-detail-tab';
import { createSearchValidator } from '@/lib/search-validators';
export const Route = createFileRoute('/_app/fleet-management/drivers/new')({
  // `Record<never, ...>`, not `Record<string, ...>`: a `string` index signature would
  // poison the merged search type with an implicit `[x: string]: never`, breaking the
  // `search: prev => ({ ...prev, tab })` navigate updater below.
  validateSearch: createSearchValidator<Record<never, string | undefined>, DriverDetailTab>({
    tabs: DRIVER_DETAIL_TABS,
    filterKeys: []
  }),
  staticData: {
    breadCrumb: 'Add Driver'
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});